import { render, staticRenderFns } from "./SignupSuccess.vue?vue&type=template&id=196280c0&"
import script from "./SignupSuccess.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SignupSuccess.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports